import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/shadcn-ui/dialog';
import { Button } from '@/components/shadcn-ui/button';

function AcknowledgmentModal({ isOpen, onClose, onSubmit, generalContent, acknowledgements = [] }) {
    const [step, setStep] = useState(1);
    const [generalChecked, setGeneralChecked] = useState(false);
    const [checkedState, setCheckedState] = useState({});

    useEffect(() => {
        if (isOpen) {
            setStep(1);
            setGeneralChecked(false);
            const initial = {};
            acknowledgements.forEach((_, i) => {
                initial[i] = false;
            });
            setCheckedState(initial);
        }
        // acknowledgements intentionally omitted — effect should only reset on open/close,
        // not on every render (avoids infinite loop when acknowledgements is a new array reference each render)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    const allAckChecked = acknowledgements.length > 0 && acknowledgements.every((_, i) => checkedState[i]);

    const handleCheckAll = () => {
        const next = !allAckChecked;
        const newState = {};
        acknowledgements.forEach((_, i) => {
            newState[i] = next;
        });
        setCheckedState(newState);
    };

    const handleSubmit = () => {
        onSubmit();
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-lg dark text-white">
                <DialogHeader>
                    <DialogTitle className="text-xl font-semibold">
                        {step === 1 ? 'General Disclaimer' : 'Acknowledgements'}
                    </DialogTitle>
                    <DialogDescription className="text-sm text-muted-foreground">
                        {step === 1
                            ? 'Please read and accept the disclaimer to continue.'
                            : `Please review and acknowledge all items below. (${acknowledgements.filter((_, i) => checkedState[i]).length}/${acknowledgements.length})`}
                    </DialogDescription>
                </DialogHeader>

                {step === 1 ? (
                    <div className="mt-4 space-y-4">
                        <div className="max-h-[300px] overflow-y-auto rounded border border-border p-3 text-sm text-muted-foreground whitespace-pre-wrap">
                            {generalContent}
                        </div>
                        <label className="flex cursor-pointer items-start gap-3 text-sm">
                            <input
                                type="checkbox"
                                checked={generalChecked}
                                onChange={() => setGeneralChecked(v => !v)}
                                className="mt-0.5 size-4 shrink-0"
                            />
                            <span>I have read and agree to the above disclaimer.</span>
                        </label>
                        <Button onClick={() => setStep(2)} disabled={!generalChecked} className="w-full">
                            Next
                        </Button>
                    </div>
                ) : (
                    <div className="my-2 space-y-4">
                        <div className="flex items-center justify-start line-height-1">
                            <button onClick={handleCheckAll} className="text-sm underline text-primary cursor-pointer text-end">
                                {allAckChecked ? 'Uncheck All' : 'Check All'}
                            </button>
                        </div>
                        <div className="max-h-[300px] space-y-3 overflow-y-auto pr-1">
                            {acknowledgements.map((item, i) => (
                                <label key={i} className="flex cursor-pointer items-start gap-3 text-sm">
                                    <input
                                        type="checkbox"
                                        checked={checkedState[i] || false}
                                        onChange={() => setCheckedState(prev => ({ ...prev, [i]: !prev[i] }))}
                                        className="mt-0.5 size-4 shrink-0"
                                    />
                                    <span>{item}</span>
                                </label>
                            ))}
                        </div>
                        <div className="flex gap-2">
                            <Button variant="outline" onClick={() => setStep(1)} className="flex-1">
                                Back
                            </Button>
                            <Button onClick={handleSubmit} disabled={!allAckChecked} className="flex-1">
                                Submit
                            </Button>
                        </div>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
}

export default AcknowledgmentModal;